export default __webpack_public_path__ + "c13b6640e473f585cf37a09c018e7889.jpg";